export function GameLog(message?: any, ...optionalParams: any[]) {
    // if (window.location.href.indexOf('localhost') === -1) return;
    dispatchEvent(new CustomEvent('GameLog', { detail: { message, optionalParams: [...optionalParams] } }));
    console.log(message, ...optionalParams);
}
